import {Button, Dropdown, MenuProps} from "antd";
import {DeleteOutlined, EditOutlined, EyeOutlined, MoreOutlined} from "@ant-design/icons";
import "./style.less";

type ActionsMenuProps = {
  onDetails?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  label?: string;
  className?: string;
};

const ActionsMenu = ({onDetails, onEdit, onDelete, label = "Дії", className = ""}: ActionsMenuProps) => {
  const items: MenuProps['items'] = [];
  if (onDetails) items.push({key: 'details', label: 'Детальніше', icon: <EyeOutlined/>, onClick: onDetails});
  if (onEdit) items.push({key: 'edit', label: 'Редагувати', icon: <EditOutlined/>, onClick: onEdit});
  if (onDelete) items.push({key: 'delete', label: 'Видалити', icon: <DeleteOutlined/>, danger: true, onClick: onDelete});
  if (!items.length) return null;

  return <Dropdown menu={{items, onClick: ({domEvent}) => domEvent.stopPropagation()}} trigger={['click']} placement="bottomRight">
    <Button className={`action-button ${className}`} icon={<MoreOutlined/>} aria-label={label}
            title={label} onClick={event => event.stopPropagation()}/>
  </Dropdown>;
};

export default ActionsMenu;
